let lazyObserver;
const visibilityIntervals = new WeakMap();
const lazyLoadStages = [
    {
        delay: 0,
        rootMargin: '0px 200px 400px 10px'
    },
    {
        delay: 3000,
        rootMargin: '0px 800px 1200px 1000px'
    },
    {
        delay: 5000,
        rootMargin: '1000px 3000px 3000px 3000px'
    }
];

function getLazyMedia() {
    return document.querySelectorAll('img[lazy-load],source[lazy-load]');
}

function clearVisibilityInterval(media) {
    const interval = visibilityIntervals.get(media);

    if (interval) {
        clearInterval(interval);
        visibilityIntervals.delete(media);
    }
}

function loadMedia(media) {
    clearVisibilityInterval(media);

    if (media.tagName === 'SOURCE') {
        if (media.hasAttribute('data-adaptive-src') && window.matchMedia("(max-width: 767px)").matches) {
            media.src = media.dataset.adaptiveSrc;
            media.dataset.adaptiveSrc = media.dataset.src;
            media.setAttribute('mobile-media', '');
        } else {
            media.src = media.dataset.src;
        }

        media.removeAttribute('data-src');
        media.closest('video')?.load();

    } else {

        if (media.dataset.srcset) {
            media.srcset = media.dataset.srcset;
            media.removeAttribute('data-srcset');
        }

        if (media.dataset.sizes) {
            media.sizes = media.dataset.sizes;
            media.removeAttribute('data-sizes');
        }

        if (media.dataset.src) {
            media.src = media.dataset.src;
            media.removeAttribute('data-src');
        }
    }

    media.removeAttribute('lazy-load');
    // media.classList.add('lazy-loaded');
    media.setAttribute('lazy-loaded', 'true');
}

function isElementVisible(media) {
    const style = window.getComputedStyle(media);
    return style.display !== 'none' && style.visibility !== 'hidden' && media.offsetParent !== null;
}

function loadIfVisible(media, observer) {
    if (isElementVisible(media)) {
        loadMedia(media);
        observer.unobserve(media);
    }
}

function observeMedia(media) {

    if (!lazyObserver || !media.hasAttribute('lazy-load')) {
        return;
    }

    lazyObserver.observe(media);

    if (!isElementVisible(media) && !visibilityIntervals.has(media)) {
        const interval = setInterval(() => {

            if (!media.isConnected || !media.hasAttribute('lazy-load')) {
                clearVisibilityInterval(media);
                return;
            }

            if (isElementVisible(media)) {
                loadMedia(media);
                lazyObserver?.unobserve(media);
                clearVisibilityInterval(media);
            }

        }, 200);

        visibilityIntervals.set(media, interval);
    }
}

function createLazyObserver(rootMargin) {
    return new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadIfVisible(entry.target, observer);
            }
        });

    }, {
        root: null,
        rootMargin,
        threshold: 0
    });
}

function updateLazyObserver(rootMargin) {
    const pendingMedia = Array.from(getLazyMedia()).filter(media => media.hasAttribute('lazy-load'));

    lazyObserver?.disconnect();
    lazyObserver = createLazyObserver(rootMargin);

    pendingMedia.forEach(observeMedia);
}

function scheduleLazyLoadStages() {
    lazyLoadStages.slice(1).forEach(stage => {
        window.setTimeout(() => {
            updateLazyObserver(stage.rootMargin);
        }, stage.delay);
    });
}

function loadAboveFold(threshold) {
    const cutoff = document.documentElement.scrollHeight * threshold;
    getLazyMedia().forEach(media => {
        if (media.hasAttribute('lazy-load')) {
            const rect = media.getBoundingClientRect();
            const absoluteTop = rect.top + window.scrollY;
            if (absoluteTop < cutoff) {
                loadMedia(media);
            }
        }
    });
}

function initLazyLoad() {
    loadAboveFold(0.6);
    updateLazyObserver(lazyLoadStages[0].rootMargin);
    scheduleLazyLoadStages();
}


function reloadLazyLoad() {

    getLazyMedia().forEach(media => {
        if (media.hasAttribute('lazy-load')) {
            observeMedia(media);
        }
    });

}

/* INIT */

document.addEventListener('DOMContentLoaded', function () {

    initLazyLoad();

    const mutationObserver = new MutationObserver(mutations => {

        mutations.forEach(mutation => {

            mutation.addedNodes.forEach(node => {

                if (node.nodeType === 1) {

                    if (node.matches('img[lazy-load],source[lazy-load]')) {
                        observeMedia(node);
                    }

                    node.querySelectorAll &&
                    node.querySelectorAll('img[lazy-load],source[lazy-load]')
                        .forEach(observeMedia);

                }

            });

        });

    });

    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

});